import { IntRange } from "lavva.exalushome/build/js/Helpers";

export type Minutes = IntRange<0, 60>;
export type Seconds = IntRange<0, 60>;
export type Hours = IntRange<0, 24>;

export interface ITime {
    get Seconds(): Seconds;
    set Seconds(value: Seconds);
    get Hours(): number;
    set Hours(value: number);
    get Minutes(): Minutes;
    set Minutes(value: Minutes);
    get Raw(): number
}

export class Time {
    private _hours: Hours = 0;
    private _minutes: Minutes = 0;
    private _seconds: Seconds = 0;
    protected _raw: number = 0;

    public get Raw(): number {
        return this._raw;
    }
    public get Hours(): Hours {
        return this._hours;
    }
    public set Hours(value: Hours) {
        this._hours = value;
    }
    public get Minutes(): Minutes {
        return this._minutes;
    }
    public set Minutes(value: Minutes) {
        this._minutes = value;
    }
    public get Seconds(): Seconds {
        return this._seconds;
    }
    public set Seconds(value: Seconds) {
        this._seconds = value;
    }
}

export class StateOfTurnOnSwitchDeviceParameters {
    Channel: number = 0;
    State: SwitchTurnOnState = SwitchTurnOnState.Disabled;
}

export enum SwitchTurnOnState {
    Disabled = 0,
    Enabled = 1,
    PreviousState = 2
}

export class GlobalTimeParameters {
    Channel: number = 0;
    Time: ITime = new Time();
}

export interface IInputOutputSwitchParameters {
    get Channel(): number;
    get InputsNumber(): number;
    get InputMode(): InputModeSwitch;
    get ReactionToInput(): ReactionToInput;
    get InputChannel(): number;
}

export class InputModeSwitchParams {
    Channel: number = 0;
    InputChannel: number = 0;
    InputMode: InputModeSwitch = InputModeSwitch.Bistable;
}

export class ReactionToInputSwitchParams {
    Channel: number = 0;
    InputChannel: number = 0;
    ReactionToInput: ReactionToInput = ReactionToInput.None
}

export enum InputModeSwitch {
    Monostable = 0,
    Bistable = 1
}

export class InputOutputSwitchParameters implements IInputOutputSwitchParameters {
    private _channel: number = 0;
    private _inputsNumber: number = 0;
    private _inputMode: InputModeSwitch = InputModeSwitch.Monostable;
    private _reactionToInput: ReactionToInput = ReactionToInput.None;
    private _inputChannel: number = 0;

    public get Channel(): number {
        return this._channel;
    }
    public set Channel(value: number) {
        this._channel = value;
    }
    public get InputsNumber(): number {
        return this._inputsNumber;
    }
    public get InputMode(): InputModeSwitch {
        return this._inputMode;
    }
    public set InputMode(value: InputModeSwitch) {
        this._inputMode = value;
    }
    public get ReactionToInput(): ReactionToInput {
        return this._reactionToInput;
    }
    public set ReactionToInput(value: ReactionToInput) {
        this._reactionToInput = value;
    }
    public get InputChannel(): number {
        return this._inputChannel;
    }
    public set InputChannel(value: number) {
        this._inputChannel = value;
    }
}

export enum ReactionToInput {
    None = 0,
    Off = 1,
    On = 2,
    Time = 3,
    Mono = 4,
    Bi = 5,
    OnOff = 6
}